<template>
  <div class="navigation-menu" @click.self='openMenu'>
    <div class="logo" @click='openMenu'>
      <span class="icon"><img src="../image/logo_icon.png"></span>
      <span class="continuation"><img src="../image/logo_continuation.png"></span>
    </div>
    <ul class="navigation-list" @click.self='openMenu'>
      <li :class="{active: $route.name == 'AllOrders' ||  $route.name == 'Order'}">
        <router-link to="/orders" title="Все заказы">
          <span class="icon"><img src="../image/requests.svg"></span>Все заказы
        </router-link>
      </li>
      <li :class="{active: $route.path.includes('workers-base')}"
          v-if="show(['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_DISPATCHER', 'ROLE_HR'])">
        <router-link to="/workers-base" title="База рабочих">
          <span class="icon"><img src="../image/workers_base.svg"></span>База рабочих
        </router-link>
      </li>
      <li :class="{active: $route.name === 'WorkersInShift'}"
          v-if="show(['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_DISPATCHER', 'ROLE_HR'])">
        <router-link to="/workers-in-shift" title="Рабочие в смене">
          <span class="icon"><img src="../image/work_schedule.svg"></span>Рабочие в смене
        </router-link>
      </li>
      <li :class="{active: $route.path.includes('cashbox')}" v-if="show(['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'])">
        <router-link to="/cashbox" title="Касса">
          <span class="icon"><img src="../image/cashbox.svg"></span>Касса
        </router-link>
      </li>
      <li :class="{active: $route.path.includes('directories')}" v-if="show(['ROLE_SUPER_ADMIN'])">
        <router-link to="/directories" title="Справочники">
          <span class="icon"><img src="../image/directorys.svg"></span>Справочники
        </router-link>
      </li>
      <li :class="{active: $route.path.includes('settings')}" v-if="show(['ROLE_SUPER_ADMIN'])">
        <router-link to="/settings" title="Настройки">
          <span class="icon"><img src="../image/tools.svg"></span>Настройки
        </router-link>
      </li>
    </ul>
    <div class="developer" onclick="location.href = 'https://www.itbrick.ru/index.htm'">
      <span class="icon"><img src="../image/developer.svg"></span><a href="https://www.itbrick.ru/index.htm"
                                                                     target="_blank" title="Разработка программ">О
      разработчике</a>
    </div>
  </div>
</template>

<script>
    import utils from '@/utils'

    export default {
  name: 'MenuDispatcher',

  mounted () {
    let isMenuOpened = sessionStorage.getItem('menuDispatcher') == 'open'
    document
      .getElementsByClassName('page-wrapper')[0]
      .classList
      .toggle('open-menu-wrapper', isMenuOpened)
  },

  methods: {
    openMenu () {
      let isMenuOpened = sessionStorage.getItem('menuDispatcher') == 'open'
      document
        .getElementsByClassName('page-wrapper')[0]
        .classList
        .toggle('open-menu-wrapper', !isMenuOpened)

      if (isMenuOpened) { sessionStorage.setItem('menuDispatcher', 'close') } else { sessionStorage.setItem('menuDispatcher', 'open') }
    },
    show (accessForRoles) {
      return utils.checkRole(this.$store.getters.roleCode, accessForRoles)
    }
  }
}
</script>
